'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _RecrutementIcon = _interopRequireDefault(require("Icons/RecrutementIcon"));
var _FormationIcon = _interopRequireDefault(require("Icons/FormationIcon"));
var _PreparationEmploiIcon = _interopRequireDefault(require("Icons/PreparationEmploiIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let app = window.app;
class MaintienEmploiPage extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Accueil | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--txt"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recruteurs"
    }, "Recruteurs"), "/ ", /*#__PURE__*/_react.default.createElement("span", {
      className: "blue-text"
    }, "Maintien dans l'emploi de collaborateurs")), /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title"
    }, "Maintien dans l'emploi de collaborateurs"), /*#__PURE__*/_react.default.createElement("p", null, "Pour les entreprises qui rencontrent un probl\xE8me de maintien dans l\u2019emploi d\u2019 un collaborateur, nous intervenons pour r\xE9aliser un diagnostic, proposer un programme d\u2019intervention et le mettre en \u0153uvre."), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--blue u-margin-top-40",
      href: "/inscription-entreprise"
    }, "Inscrivez-vous gratuitement")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--img"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/aspiejob-personnesasperger.svg",
      className: "c-candidat-project_img"
    }))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Ce que nous vous proposons \xE9galement"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid c-parcours-grid--4"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recrutement-et-integration",
      className: "c-parcours-grid-item c-parcours-grid-item--green"
    }, /*#__PURE__*/_react.default.createElement(_RecrutementIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Recrutement et int\xE9gration de candidats"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recrutement-et-integration",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/formation-sensibilisation",
      className: "c-parcours-grid-item c-parcours-grid-item--orange"
    }, /*#__PURE__*/_react.default.createElement(_PreparationEmploiIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Pr\xE9paration Op\xE9rationnelle \xE0 l\u2019Emploi"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/preparation-a-l-emploi",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/formation-sensibilisation",
      className: "c-parcours-grid-item c-parcours-grid-item--blue"
    }, /*#__PURE__*/_react.default.createElement(_FormationIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Formations & Sensibilisation"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/formation-sensibilisation",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")))));
    return output;
  }
}
exports.default = MaintienEmploiPage;
